/**
 * Detects the user's region using multiple IP geolocation services with fallback.
 * Returns an object containing country code, currency, and symbol.
 */
export const detectUserRegion = async () => {
    let detectedCountry = 'US';
    let detectedCurrency = 'USD';
    let detectedSymbol = '$';
    let detectedProvider = 'stripe';

    try {
        console.log("Detecting user location using frontend services...");

        // Try multiple frontend IP detection services with fallback
        const services = [
            'https://ipapi.co/json/',
            'https://api.ipify.org?format=json',
            'https://ipinfo.io/json',
            'https://api.myip.com'
        ];

        let geoData = null;

        for (const service of services) {
            try {
                console.log(`Trying IP detection service: ${service}`);
                const response = await fetch(service, {
                    timeout: 3000,
                    mode: 'cors'
                });

                if (response.ok) {
                    geoData = await response.json();
                    console.log(`IP detection successful with ${service}:`, geoData);
                    break;
                }
            } catch (serviceError) {
                console.log(`Service ${service} failed:`, serviceError.message);
                continue;
            }
        }

        if (geoData) {
            // Handle different response formats
            if (geoData.country_code) {
                detectedCountry = geoData.country_code;
            } else if (geoData.country) {
                detectedCountry = geoData.country;
            } else if (geoData.countryCode) {
                detectedCountry = geoData.countryCode;
            } else {
                detectedCountry = 'US';
            }

            // Set payment provider and currency based on country
            if (detectedCountry === 'IN' || detectedCountry === 'IND') {
                detectedProvider = 'razorpay';
                detectedCurrency = 'INR';
                detectedSymbol = '₹';
            } else {
                detectedProvider = 'stripe';
                detectedCurrency = 'USD';
                detectedSymbol = '$';
            }

            console.log(`🌍 Country detected: ${detectedCountry}`);
            console.log(`💱 Currency: ${detectedCurrency} (${detectedSymbol})`);
            console.log(`💳 Payment provider: ${detectedProvider}`);

            return {
                country: detectedCountry,
                currency: detectedCurrency,
                symbol: detectedSymbol,
                provider: detectedProvider
            };
        }
    } catch (geoError) {
        console.error("Error detecting location:", geoError);
    }

    // Default fallback
    return {
        country: 'US',
        currency: 'USD',
        symbol: '$',
        provider: 'stripe'
    };
};
